import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Launch = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M23.2 17.44a1 1 0 00-1 1V27H5V9.78h8.6a1 1 0 100-2H4a1 1 0 00-1 1V28a1 1 0 001 1h19.2a1 1 0 001-1v-9.56a1 1 0 00-1-1z" }),
    React.createElement("path", { d: "M28.92 3.62a1 1 0 00-.21-.32A1 1 0 0028 3h-9.6a1 1 0 000 2h7.19L8.09 22.51a1 1 0 101.41 1.41L27 6.42v7.19a1 1 0 002 0V4a1 1 0 00-.08-.38z" })), '0 0 32 32', 'Launch');
//# sourceMappingURL=Launch.js.map